import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-desks',
  templateUrl: './turns-desks.component.html',
  styleUrls: ['./turns-desks.component.scss']
})
export class TurnsDesksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
